// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const InsuranceFinancingSvg = ({ color, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 35 35"
    role="presentation"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M13.39 25.266c.5 0 .943-.438.943-.93v-1.313h.166c1.833 0 3.333-1.476 3.333-3.28 0-1.805-1.5-3.282-3.333-3.282h-.11v-2.843h1.777c.5 0 .944-.437.944-.93 0-.492-.443-.93-.943-.93H14.39v-1.312c0-.492-.446-.93-.946-.93-.5 0-.944.438-.944.93v1.313h-.11c-1.834 0-3.334 1.476-3.334 3.28 0 1.806 1.5 3.282 3.333 3.282h.11v2.789h-1.89c-.5 0-.943.437-.943.93 0 .49.444.93.944.93h1.89v1.31a.9.9 0 00.89.986zm1-4.21V18.32h.11c.778 0 1.444.657 1.444 1.422 0 .766-.666 1.422-1.444 1.422h-.168v-.11h.056zm-2.057-4.65c-.777 0-1.444-.656-1.444-1.422 0-.765.666-1.421 1.443-1.421h.11v2.79h-.11v.053zm9.445 5.852v2.297h-1.5c-.5 0-.945.437-.945.93v8.476c0 .493.445.93.945.93H33.61c.5 0 .946-.437.946-.93v-8.476c0-.492-.445-.93-.945-.93h-1.5V22.26c0-2.79-2.332-5.086-5.166-5.086-2.833 0-5.166 2.297-5.166 5.086zm10.89 4.21v6.618H21.22V26.47h11.445zm-2.446-4.21v2.297h-6.555v-2.297c0-1.75 1.444-3.227 3.277-3.227 1.778 0 3.278 1.478 3.278 3.228zM22.278 9.406H26v5.196c0 .492.444.93.944.93.5 0 .945-.438.945-.93V8.257a.42.42 0 00-.112-.218v-.056c-.056-.054-.11-.164-.167-.218l-8-7.602c-.054-.055-.11-.11-.166-.11h-.055C19.332 0 19.22 0 19.166 0H4.28C1.888 0 0 1.914 0 4.21v26.142c0 2.35 1.944 4.21 4.278 4.21H16.61c.5 0 .946-.437.946-.93 0-.49-.445-.93-.945-.93H4.28c-1.334 0-2.39-1.038-2.39-2.35V4.212c0-1.314 1.056-2.353 2.39-2.353H18v3.335c0 2.297 1.89 4.21 4.278 4.21zm-2.39-6.29l4.668 4.43h-2.278c-1.334 0-2.39-1.038-2.39-2.35v-2.08z"
    />
  </svg>
);
InsuranceFinancingSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default InsuranceFinancingSvg;
